// FloatButton.tsx
import styled from 'styled-components';

const FloatButton = () => {
  return (
    <StyledLink href="https://nicetomeetyou.oopy.io/" target="_blank" rel="noopener noreferrer">
      <Content>
        <PhoneIcon />
        <TextWrapper>
          <Text>
            전화로 <br />
            해결하기
          </Text>
        </TextWrapper>
      </Content>
    </StyledLink>
  );
};

export default FloatButton;

// ✅ 대체용 전화 아이콘 SVG 컴포넌트
const PhoneIcon = () => (
  <svg width="20" height="20" fill="white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.11-.21 11.36 11.36 0 0 0 3.58.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.25a1 1 0 0 1 1 1 11.36 11.36 0 0 0 .57 3.58 1 1 0 0 1-.21 1.11l-2.2 2.2z" />
  </svg>
);

// ✅ styled-components
const StyledLink = styled.a`
  min-width: 5rem;
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  display: flex;
  height: 3.5rem;
  width: 10rem;
  max-width: 140px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0.75rem;
  border: 1.5px solid #f42d16;
  background: #f42d16;
  box-shadow:
    0px 4px 8px 3px rgba(0, 0, 0, 0.15),
    0px 1px 3px 0px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease-in-out;
  text-decoration: none;
  &:hover {
    transform: scale(1.05);
  }

  @media (min-width: 768px) {
    max-width: none;
  }
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;

  @media (min-width: 768px) {
    padding: 1rem 1.5rem;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Text = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25rem;
  letter-spacing: 0.1px;
  color: white;
  text-align: start;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;
